export default __webpack_public_path__ + "2e95a3ff3baf95b44e86dbcaef8fe10a.mp3";